import { Form, Select } from 'antd';
import React from 'react';
import { FormInstance } from 'antd/lib/form/Form';
import styled from 'styled-components';
import { TUsers } from './type';
import {
    EInvoiceInput,
    EInvoiceInputPassword,
} from '../../components/form/input';
import { EInvoiceForm } from '../../components/form/form';
import { getTenants } from '../../api/setting/tenants';
import { SearchQueryParams } from '../../interface/paging';
import { DEFAULT_PAGE_SIZE_FULL } from '../../utils/constants';
import { TTenants } from '../tenants/type';

const Wrapper = styled.div`
    .ant-row {
        align-items: center;
    }
    .ant-form-item-has-error {
        .ant-row {
            align-items: flex-start;
        }
    }
`;

type UserFormProps = {
    userData: TUsers | undefined;
    form: FormInstance;
};
export const UserForm: React.FC<UserFormProps> = ({ userData, form }) => {
    const [tenantList, setTenantList] = React.useState<TTenants[]>([]);
    const loadTenants = React.useCallback(async () => {
        try {
            const payload = {
                page: 1,
                pageSize: DEFAULT_PAGE_SIZE_FULL,
            } as SearchQueryParams;
            const result = await getTenants(payload);
            if (result.status === 200) {
                setTenantList(result.data?.data?.tenants ?? []);
            }
        } catch (error) {
            // Handle error
        }
    }, []);

    React.useEffect(() => {
        loadTenants();
    }, []);

    const childForm = (
        <div className="grid gap-[10px] grid-cols-[1fr]">
            <Form.Item
                name="username"
                label="Name"
                rules={[
                    {
                        required: true,
                        message: 'Please input the name!',
                    },
                ]}
            >
                <EInvoiceInput isRequired={true} />
            </Form.Item>
            <Form.Item
                name="password"
                label="Password"
                rules={[
                    {
                        required: true,
                        message: 'Please input the password!',
                    },
                ]}
            >
                <EInvoiceInputPassword
                    size="large"
                    maxLength={20}
                    placeholder="Password"
                />
            </Form.Item>
            <Form.Item
                name="tenant_id"
                label="Tenant"
                rules={[
                    {
                        required: true,
                        message: 'Please select the tenant!',
                    },
                ]}
            >
                <Select
                    placeholder="Select a tenant"
                    allowClear
                    size="large"
                    onChange={() => {}}
                    options={tenantList.map(item => ({
                        label: item.name,
                        value: item.id,
                    }))}
                />
            </Form.Item>
        </div>
    );

    React.useEffect(() => {
        if (userData) {
            form.setFieldsValue({
                username: userData.username,
                password: userData.password,
                tenant_id: userData.tenant_id,
            });
        }
    }, [userData, form]);

    return (
        <Wrapper className="flex flex-col gap-[20px] w-full overflow-hidden h-full items-start box-border py-[20px] px-[5px]">
            <EInvoiceForm
                labelCol={{ flex: '130px' }}
                labelAlign="left"
                form={form}
                labelWrap
                wrapperCol={{ flex: 1 }}
                layout="horizontal"
                className="w-full"
                name="createUser"
                childNode={childForm}
            />
        </Wrapper>
    );
};
